import { cn } from '@/lib/utils';

interface SwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  'aria-label'?: string;
  className?: string;
}

/**
 * iOS-style toggle (OG `.v16-switch`): 44×26 track, 20px knob, 18px travel.
 * Off is a faint white track; on is the iOS green with a soft glow. Rendered as
 * a `role="switch"` button so it's keyboard- and screen-reader-accessible.
 */
export function Switch({ checked, onChange, disabled, className, ...rest }: SwitchProps) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      disabled={disabled}
      onClick={() => onChange(!checked)}
      className={cn(
        'relative h-[26px] w-11 shrink-0 rounded-pill transition-colors duration-200',
        'disabled:cursor-not-allowed disabled:opacity-50',
        checked ? 'bg-toggle-on shadow-[0_0_12px_rgba(52,199,89,0.35)]' : 'bg-white/10',
        className,
      )}
      {...rest}
    >
      <span
        className={cn(
          'absolute left-[3px] top-[3px] h-5 w-5 rounded-full bg-white shadow-[0_2px_4px_rgba(0,0,0,0.3)] transition-transform duration-200',
          checked && 'translate-x-[18px]',
        )}
      />
    </button>
  );
}
